<template>
  <div class="contact">
    <!-- Header Image Section with Contact Info -->
    <div class="header-image">
      <div class="header-overlay">
        <div class="header-content">
          <h1>Contact Us</h1>
          
          <div class="header-contact-info">
            <div class="contact-info-item">
              <div class="info-text">
                <p class="email-text">office@innovatics.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="container">
      <div class="contact-container">
        <!-- Contact Form Section -->
        <div class="form-section">
          <div class="contact-header">
            <div class="contact-header-content">
              <font-awesome-icon :icon="['fas', 'envelope']" class="envelope-icon" />
              <h2>Let's get in touch</h2>
            </div>
            <p class="contact-intro">Got a question? Drop us a line and we'll be back to you in no time.</p>
          </div>
          <form @submit.prevent="handleSubmit" class="contact-form">
            <div class="form-group">
              <label for="inquiry">Select reasons of inquiry</label>
              <select id="inquiry" v-model="formData.inquiry" required>
                <option value="" disabled selected>Select an option</option>
                <option value="general">General Inquiry</option>
                <option value="support">Support</option>
                <option value="sales">Sales</option>
                <option value="partnership">Partnership</option>
              </select>
            </div>
            
            <div class="form-group">
              <label for="source">How did you hear about us?</label>
              <select id="source" v-model="formData.source" required>
                <option value="" disabled selected>Select an option</option>
                <option value="search">Search Engine</option>
                <option value="social">Social Media</option>
                <option value="referral">Referral</option>
                <option value="other">Other</option>
              </select>
            </div>
            
            <div class="form-row">
              <div class="form-group">
                <label for="firstName">First name</label>
                <input 
                  type="text" 
                  id="firstName" 
                  v-model="formData.firstName" 
                  required 
                  placeholder="John"
                >
              </div>
              
              <div class="form-group">
                <label for="lastName">Last name</label>
                <input 
                  type="text" 
                  id="lastName" 
                  v-model="formData.lastName" 
                  required 
                  placeholder="Doe"
                >
              </div>
            </div>
            
            <div class="form-group">
              <label for="email">Email address</label>
              <input 
                type="email" 
                id="email" 
                v-model="formData.email" 
                required 
                placeholder="john@example.com"
              >
            </div>
            
            <div class="form-group">
              <label for="message">Your message</label>
              <textarea 
                id="message" 
                v-model="formData.message" 
                rows="5" 
                required
                placeholder="Type your message here..."
              ></textarea>
            </div>
            
            <div class="form-group">
              <div class="privacy-container">
                <div class="privacy-row">
                  <div class="checkbox-wrapper">
                    <input 
                      type="checkbox" 
                      id="privacyPolicy" 
                      v-model="formData.privacyPolicy"
                      required
                    >
                  </div>
                  <label for="privacyPolicy" class="privacy-label">
                    I confirm I have read and accept the <router-link to="/privacy-policy" class="privacy-link">data privacy policy</router-link>*
                  </label>
                </div>
                <p class="recaptcha-notice">
                  This site is protected by reCAPTCHA and the Google 
                  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a> and 
                  <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer">Terms of Service</a> apply.
                </p>
              </div>
            </div>
            
            <div class="form-group button-container">
              <button type="submit" class="submit-btn">
                <span v-if="!isSubmitting">Send Message</span>
                <span v-else class="loading">Sending...</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    
    <!-- CTA Section (match Home/Services) -->
    <section class="cta">
      <div class="container">
        <div class="cta-social" style="order: -1; justify-content: flex-start; text-align: left;">
          <div class="social-title">Follow us!</div>
          <div class="social-icons">
            <a href="https://www.linkedin.com/company/advancedinnovaticssolutions/about/?viewAsMember=true" aria-label="LinkedIn" class="social-icon" target="_blank" rel="noopener">
              <span>in</span>
            </a>
            <!--
            <a href="#" aria-label="Instagram" class="social-icon" target="_blank" rel="noopener">
              <span>ig</span>
            </a>
             <a href="#" aria-label="Facebook" class="social-icon" target="_blank" rel="noopener">
              <span>f</span>
            </a>
            <a href="#" aria-label="Twitter" class="social-icon" target="_blank" rel="noopener">
              <span>X</span>
            </a> -->
          </div>
        </div>
        <div class="cta-content" style="order: 1;">
          <h2>Ready to transform your business?</h2>
          <router-link to="/contact" class="btn btn-white">Let's connect</router-link>
          <div class="cta-quick-links">
            <h3>Quick Links</h3>
            <ul>
              <li><router-link to="/">Home</router-link></li>
              <li><router-link to="/services">Services</router-link></li>
              <li><router-link to="/about">About Us</router-link></li>
              <li><router-link to="/careers">Careers</router-link></li>
              <li><router-link to="/contact">Contact</router-link></li>
            </ul>
          </div>
          <div class="cta-footer">Copyright &copy; 2025 Advanced Innovatics Solutions | All rights reserved.</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactView',
  data() {
    return {
      formData: {
        inquiry: '',
        source: '',
        firstName: '',
        lastName: '',
        email: '',
        message: '',
        privacyPolicy: false
      },
      isSubmitting: false
    }
  },
  methods: {
    handleSubmit() {
      this.isSubmitting = true;
      
      // Simulate form submission
      setTimeout(() => {
        alert('Thank you for your message! We will get back to you soon.');
        this.formData = {
          inquiry: '',
          source: '',
          firstName: '',
          lastName: '',
          email: '',
          message: '',
          privacyPolicy: false
        };
        this.isSubmitting = false;
      }, 1500);
    }
  }
}
</script>

<style scoped>
/* Header Image Styles */
.header-image {
  width: 100%;
  height: 500px; /* Increased height to accommodate contact info */
  background-image: url('@/assets/images/image.png');
  background-size: cover;
  background-position: center 40%;
  background-repeat: no-repeat;
  position: relative;
  margin-top: 0;
  margin-bottom: 4rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  color: white;
}

.header-overlay {
  background: linear-gradient(to bottom, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0.7) 100%);
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  padding: 2rem;
}

.header-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  min-height: 400px; /* Adjust based on your banner height */
  padding-bottom: 40px;
  position: relative;
}

.header-contact-info {
  margin-bottom: 20px;
}

.contact-info-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.info-text {
  margin-left: 0;
}

.email-text {
  color: white;
  font-size: 1.2rem;
  margin: 0;
  padding: 0;
  text-decoration: none;
  display: inline-block;
  position: relative;
  font-weight: 500;
}

h1 {
  font-size: 3rem;
  margin: 0;
  color: white;
  text-align: left;
  font-weight: 700;
}

/* Remove any existing icon styles */
.info-icon {
  display: none;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .header-content {
    min-height: 300px;
    padding-bottom: 30px;
  }
  
  h1 {
    font-size: 2.5rem;
  }
  
  .email-text {
    font-size: 1rem;
  }
}

/* Update container and form section */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.contact-container {
  max-width: 800px;
  margin: 3rem auto;
  padding: 0;
}

.form-section {
  width: 100%;
}

.contact-header {
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e2e8f0;
}

.contact-header-content {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.contact-header h2 {
  font-size: 1.5rem;
  color: #2c3e50;
  margin: 0;
  margin-left: 0.75rem;
  font-weight: 600;
}

.contact-intro {
  color: #666;
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
}

.envelope-icon {
  color: #4361ee;
  font-size: 1.5rem;
  margin-top: 0.25rem;
}

/* Form styles */
.contact-form {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: 0 0.5rem;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.form-group {
  margin-bottom: 1.5rem;
  width: 100%;
  box-sizing: border-box;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #2c3e50;
  font-size: 1rem;
  width: 100%;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  box-sizing: border-box;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-color: #fff;
  min-height: 3rem;
  max-width: 100%;
  -webkit-tap-highlight-color: transparent;
}

/* Custom select dropdown */
.form-group select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%236b7280' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 1rem center;
  background-size: 1em;
  padding-right: 2.5rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

textarea {
  min-height: 120px;
  resize: vertical;
  -webkit-overflow-scrolling: touch;
}

/* Form row layout */
.form-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  width: 100%;
  box-sizing: border-box;
}

/* Mobile Responsive Styles */
@media (max-width: 768px) {
  .container {
    padding: 0 0.5rem;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
  
  .contact-container {
    margin: 1rem auto;
    padding: 0 0.25rem;
    width: 100%;
    max-width: 100%;
  }
  
  .form-section {
    padding: 0;
    width: 100%;
  }
  
  .form-group input,
  .form-group select,
  .form-group textarea {
    font-size: 1rem;
    padding: 1rem;
    width: 100%;
    max-width: 100%;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
  
  select {
    background-position: 95% center;
  }
  
  textarea {
    min-height: 150px;
  }
  
  /* Fix for iOS zoom on focus */
  @media (max-width: 480px) {
    input, 
    select, 
    textarea {
      font-size: 16px !important;
    }
    
    /* Prevent iOS from zooming on focus */
    @supports (-webkit-overflow-scrolling: touch) {
      input, 
      select, 
      textarea {
        font-size: 16px !important;
      }
    }
  }
}

/* For larger screens */
@media (min-width: 769px) {
  .form-row {
    grid-template-columns: 1fr 1fr;
    gap: 1.5rem;
  }
}

/* CTA Section (match Home/Services) */
.cta {
  background: linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%);
  color: white;
  text-align: left;
  padding: 6rem 0;
  margin-top: 4rem;
}

.cta .container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; /* allow footer to sit on its own row */
  gap: 1rem;
}

.cta .cta-content {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 1rem;
  flex-wrap: wrap; /* allow footer to go under the button */
  order: 1; /* place CTA text/buttons on the right */
}

.cta .cta-content .cta-footer {
  flex: 0 0 100%; /* full width row within CTA content */
  text-align: left; /* bottom-left alignment */
  margin-top: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.95rem;
}

.cta h2 { color: #ffffff; }

.cta .btn-white {
  background: transparent;
  color: #ffffff;
  border: 3px solid #ffffff;
  border-radius: 9999px;
  padding: 0.75rem 1.75rem;
  font-weight: 700;
  font-size: 1.125rem;
  line-height: 1.1;
  text-decoration: none;
  margin-top: 0;
}

.cta .btn-white:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.cta .cta-social {
  display: flex;
  flex-direction: row; /* title and icons on same line */
  align-items: center; /* vertically center title and icons */
  justify-content: flex-start; /* align to the left */
  gap: 0.75rem;
  text-align: left; /* left align label and icons */
  order: -1; /* ensure this appears on the left with space-between */
}

.cta .cta-social .social-title {
  font-weight: 700;
  font-size: 1.25rem;
  color: #ffffff;
}

.cta .cta-social .social-icons { display: flex; gap: 1rem; }

.cta .cta-social .social-icon {
  width: 64px;
  height: 64px;
  border: 3px solid #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  text-decoration: none;
  font-weight: 800;
  font-size: 1.25rem;
  transition: transform 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
}

.cta .cta-social .social-icon:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Quick Links inside CTA */
.cta .cta-quick-links {
  flex: 0 0 100%;
  margin-top: 1rem;
}

.cta .cta-quick-links h3 {
  margin: 0 0 0.5rem;
  font-size: 1rem;
  color: #ffffff;
}

.cta .cta-quick-links ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.cta .cta-quick-links a {
  color: #ffffff;
  text-decoration: none;
  opacity: 0.9;
}

.cta .cta-quick-links a:hover {
  text-decoration: underline;
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 768px) {
  .contact-container {
    margin: 2rem auto;
    padding: 0 1rem;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .contact-header h2 {
    font-size: 1.5rem;
  }
  
  .contact-intro {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 1rem;
  }
  
  .contact-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .contact-header h2 {
    margin-left: 0;
    margin-top: 0.5rem;
  }
}

.privacy-container {
  width: 100%;
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  box-sizing: border-box;
}

.privacy-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}

.checkbox-wrapper {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-right: 8px;
}

.privacy-row input[type="checkbox"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  border: 1.5px solid #4361ee;
  border-radius: 2px;
  outline: none;
  cursor: pointer;
  position: relative;
  margin: 0 8px 0 0;
  flex-shrink: 0;
  vertical-align: middle;
}

.privacy-row input[type="checkbox"]:checked {
  background-color: #4361ee;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='3' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 10px;
}

.privacy-label {
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.4;
  cursor: pointer;
  margin: 0;
}

.privacy-link {
  color: #4361ee;
  text-decoration: none;
  font-weight: 500;
}

.privacy-link:hover {
  text-decoration: underline;
}

.recaptcha-notice {
  font-size: 0.75rem;
  color: #6b7280;
  margin-top: 0.5rem;
  line-height: 1.4;
}

.recaptcha-notice a {
  color: #4361ee;
  text-decoration: none;
}

.recaptcha-notice a:hover {
  text-decoration: underline;
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.submit-btn {
  background: #4361ee;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: auto;
  min-width: 180px;
  margin: 0;
}

.submit-btn:hover {
  background: #3a56d4;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.loading {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
</style>
